module.exports = __webpack_public_path__ + "img/addTo.da0ff16f.svg";